import React, { useState, useEffect, useRef, MutableRefObject } from "react";
import { CheckList, CenterPopup, Divider, Toast } from "antd-mobile";
import { useSearchParams } from "react-router-dom";
import { useThrottleFn } from "ahooks";
import { useDispatch } from "react-redux";
import { UPDATE_COMMON_STATE } from "@/reducers/Common/constant";
import HLoading from "@/components/HLoading";
import useCallbackState from "./useCallbackState";
import HdlToast from "@/utils/toast";
import { areaCodeDataList, languageSelectList } from "@/utils/countryCode";
import { translateModel, templateReplace } from "@/locales";
import { $vw } from "@/utils";
import { trackLog } from "@/api/common";
import {
  couponActiveDetail,
  getGt4Captcha,
  getVerifyCode,
  loginAndSend,
} from "@/api/coupon";
import "./index.scss";
import { goToPage, loginTypeList, LOGIN_EMAIL } from "./util";
import { Chinese } from "@/locales/zh";

var FastClick = require("fastclick");
FastClick.attach(document.body);
let isCodeType: boolean = false;
let phoneReg: RegExp = /^\d{8,11}$/;
const emailReg: RegExp = /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

type TrackIdentifier =
  | "h5_active_couponpage_view"
  | "h5_active_couponpage_click"
  | "h5_active_smscode_success_show";
type TrackType = "page" | "click" | "show";
type TrackEventName =
  | "H5 领取优惠券页面浏览"
  | "H5 领取优惠券页面按钮点击"
  | "H5 领取优惠券-短信验证码发送成功"
  | "H5 领取优惠券-邮箱验证码发送成功";

const Fail_Ver_Code = "-50011";
const Time_End = "-50012";
const Not_Get_Repeat = "-50013";
const Not_Get_Eligible = "-50014";
const Send_Code_Error = "-50015";
const Network_Error = "-50016";
const Member_Status_Abnormal = "-50017";
const Send_Code_Frequently = "-50018";
const Activity_Boom = "-50019";
const ERR_NETWORK = "ERR_NETWORK";
// 错误状态
const errorStatus: any = {
  [Fail_Ver_Code]: "fail_ver_code", // 验证码错误
  [Time_End]: "time_end", // 活动结束
  [Not_Get_Repeat]: "not_get_repeat", // 重复领取
  [Not_Get_Eligible]: "not_get_eligible", // 条件不满足
  [Send_Code_Error]: "send_code_error", // 发送验证码错误
  [Network_Error]: "network_error", // 发送优惠券错误
  [Member_Status_Abnormal]: "member_status_abnormal", // 发送验证码错误
  [Send_Code_Frequently]: "send_frequently", // 发送频繁
  [Activity_Boom]: "activity_boom", // 活动火爆
  [ERR_NETWORK]: "network_error", // 网络错误
};
/* 验证码倒计时时长 */
const TIME_DURING = 90;
const ReceiveCoupon: React.FC = (props: any) => {
  let [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const loadingRef = useRef<any>(); //loading
  const phoneRef: MutableRefObject<any> = useRef(null);
  const emailRef: MutableRefObject<any> = useRef(null);
  // 翻译文案
  const [translate, setTranslate] = useState<any>();
  const translateVal = useRef();
  // 国家, 隐私协议、展示需要
  const [country, setCountry] = useState("CN");
  // 手机区号名称
  const [phoneAreaName, setPhoneAreaName] = useState("中国");
  // 活动需要根据语言调整bg
  const [detailRuleBg, setDetailRuleBg] = useState("");
  //是否展示登录弹框
  const [isImmediately, setImmediately] = useCallbackState(false);
  //是否同意用户协议和隐私政策
  const [isAgree, setAgree] = useState(false);
  //是否同意推送
  const [isAgreePush, setAgreePush] = useState(false);
  //选择面板
  const [visible, setVisible] = useState(false);
  // 语言面板
  const [languageVisible, setLanguageVisible] = useState(false);
  // 领取方式面板
  const [loginTypeVisible, setLoginTypeVisible] = useState(false);
  // 展示选择的语言
  const [languageValue, setLanguageValue] = useState("English");
  // 选择区号后，关闭弹框
  const hadChangeLanguage = useRef(false);
  // 展示选择的语言的隐私协议
  const languageCode = useRef("EN");
  //手机号
  const [phone, setPhone] = useState("");
  const phoneVal = useRef("");
  // 邮件
  const [email, setEmail] = useState("");
  // 登录方式
  const [loginType, setLoginType] = useState(LOGIN_EMAIL);
  const [isEmailLogin, setIsEmailLogin] = useState(loginType == LOGIN_EMAIL);
  //验证码
  const [verifyCode, setVerifyCode] = useState("");
  // 排序的区号
  const [sortAreaCodeDataList, setSortAreaCodeDataList] =
    useState(areaCodeDataList);
  //区号
  const [phoneAreaCode, setPhoneAreaCode] = useState("+86");
  const phoneAreaCodeVal = useRef("+86");
  //活动状态
  const [actFailStatus, setActFailStatus] = useState(false);
  const activeInfo = useRef<any>({});
  /* 国家信息语言 */
  const [languageSelectedInfo, setLanguageSelectedInfo] = useState<any>({
    value: "English",
    languageName: "英文",
    languageCode: "EN",
  });

  const captchaLanguage = useRef("eng");

  /* 验证码倒计时 */
  const [verCodeSecond, setVerCodeSecond] = useState(TIME_DURING);
  const [isGetVerCode, setIsGetVerCode] = useState(false);
  const getVerCodeTimer = useRef<any>(null);
  const currentTime = useRef(TIME_DURING);
  /** 邮箱获取验证码点击标记 */
  const emailLoginVercodeBtnFlag = useRef(false);

  /* 滑块 */
  const catptchInstance = useRef<any>(null);
  const riskTypeConfig = useRef("");

  const [getSuccessDialog, setGetSuccessDialog] = useState(false);

  /**
   * 获取活动详情
   */
  const getActivityDetail = (activityId: string) => {
    loadingRef.current.open();
    couponActiveDetail({
      activityId,
    })
      .then((res: any) => {
        console.log(res, "======================");
        loadingRef.current.close();
        // setActStatus(false)
        if (res.code == 200) {
          // 获取滑块配置
          getCaptchaConfigFn();
          const {
            country,
            timezone,
            languageImgVos,
            activityName,
            activityStatus,
            templateIdList,
            distributedComplete,
          } = res.data;
          setCountry(country || "CN");
          dispatch({
            type: UPDATE_COMMON_STATE,
            payload: {
              country: country || "CN",
              timezone: timezone || "CTT",
            },
          });
          const _defaultInfo = languageImgVos?.filter(
            (_item: any) => _item.isDefault
          )[0];
          setDetailRuleBg(_defaultInfo.url);
          /** 当前选择默认语言 */
          const _selectedLanguageInfo = languageSelectList.filter(
            (_lan: any) => _lan.languageCode == _defaultInfo.language
          )[0];
          setLanguageValue(_selectedLanguageInfo.value);
          console.log({ _selectedLanguageInfo });
          setLanguageSelectedInfo(_selectedLanguageInfo);
          captchaLanguage.current =
            _selectedLanguageInfo.captchaLanguage || "eng";
          /** 隐私协议 */
          languageCode.current = _selectedLanguageInfo.languageCode;
          /* 选择语言, 初始化 */
          const locales: any =
            translateModel(_selectedLanguageInfo.languageCode || "EN") || {};
          setTranslate(locales);
          translateVal.current = locales;
          activeInfo.current = JSON.parse(JSON.stringify(res.data));

          trackLogFn(
            "h5_active_couponpage_view",
            "page",
            "H5 领取优惠券页面浏览",
            _selectedLanguageInfo.languageName
          );
          // 活动结束或者活动没结束，但是券发没了
          if (
            activityStatus != 2 ||
            (activityStatus == 2 && distributedComplete)
          ) {
            setActFailStatus(true);
            return;
          }
        } else {
          HdlToast.info(res?.msg || (translate && translate["not_get_late"]));
          setActFailStatus(true);
        }
      })
      .catch((err) => {
        const _errorMsg =
          (err.code &&
            errorStatus[err.code] &&
            translate &&
            translate[errorStatus[err.code]]) ||
          err.msg ||
          err.message ||
          (translate && translate["not_get_late"]);
        HdlToast.info(_errorMsg);
        // err.code && HdlToast.info((translate && translate[errorStatus[err.code]]) || err.msg || (translate && translate['not_get_late']));
        setActFailStatus(true);
        loadingRef.current.close();
        console.log({ err });
      });
  };
  //处理本地数据
  useEffect(() => {
    document.title =
      (translate && translate["page_title"]) || "领取海底捞专属优惠券";
    const locales: any = translateModel("EN");
    setTranslate(locales);
    translateVal.current = locales;
    const activityId = searchParams?.get("activityId");
    activityId && getActivityDetail(activityId);
  }, [searchParams]);

  useEffect(() => {
    if (isImmediately) {
      /** 获取滑块配置 */
      // getCaptchaConfigFn();
      /** 区号排序 */
      sortAreaCodeListFn();
    }
  }, [isImmediately]);

  /* 手机区号 */
  useEffect(() => {
    // if(hadChangeLanguage.current) return;
    if (translate) {
      const _areaInfo = sortAreaCodeDataList.filter(
        (_area) => _area.code == phoneAreaCode
      )[0];
      // console.log({_areaInfo, translate});
      setPhoneAreaName(translate[_areaInfo.country]);
      document.title =
        (translate && translate["page_title"]) || "领取海底捞专属优惠券";
    }
  }, [phoneAreaCode, translate]);

  useEffect(() => {
    setIsEmailLogin(loginType == LOGIN_EMAIL);
    if (loginType != LOGIN_EMAIL) {
      initCaptcha();
    }
  }, [loginType]);

  const selectLanguageFn = (val: any) => {
    setLanguageVisible(false);
    const _selectedLanguageValue = val[0];
    /* 切换语言跟之前的一样 */
    if (!_selectedLanguageValue) {
      return;
    }
    // console.log({_selectedLanguageValue, languageValue, val},)
    setLanguageValue(_selectedLanguageValue);
    setLanguageVisible(false);
    /* 根据语言value，兑换国家编码 */
    const _selectedLanguageInfo = languageSelectList.filter(
      (_lan: any) => _lan.value == _selectedLanguageValue
    )[0];
    /* 根据语言value，找到对应语言bg，否则默认 */
    const _defaultInfo =
      activeInfo?.current?.languageImgVos?.filter(
        (_item: any) => _item.isDefault
      )[0] || {};
    const _activeInfo =
      activeInfo?.current?.languageImgVos?.filter(
        (_item: any) => _item.language == _selectedLanguageInfo?.languageCode
      )[0] || _defaultInfo;

    // console.log({_selectedLanguageValue, _activeInfo, _selectedLanguageInfo})
    setDetailRuleBg(_activeInfo.url);
    /* 设置右上角 */
    setLanguageSelectedInfo(_selectedLanguageInfo);
    console.log({ _selectedLanguageInfo }, "==============");
    captchaLanguage.current = _selectedLanguageInfo.captchaLanguage || "eng";
    /** 隐私协议 */
    languageCode.current = _selectedLanguageInfo.languageCode;
    /* 选择语言, 初始化 */
    const locales: any =
      translateModel(_selectedLanguageInfo.languageCode || "EN") || {};
    setTranslate(locales);
    translateVal.current = locales;

    if (!isEmailLogin) {
      initCaptcha();
    }
    // setPhoneAreaCode(val[0] as string);
    // translate
  };

  const sortAreaCodeListFn = () => {
    const areaCodeDataListCpoy = JSON.parse(JSON.stringify(areaCodeDataList));

    const targetCountry = country;
    let targetIndex = areaCodeDataListCpoy.findIndex(
      (_areaInfo: any) => _areaInfo.country === targetCountry
    );

    if (targetIndex !== -1 && targetIndex !== 0) {
      // 使用 splice 移除对象，并使用 unshift 将其添加到第一位
      const targetArea = areaCodeDataListCpoy.splice(targetIndex, 1)[0];
      areaCodeDataListCpoy.unshift(targetArea);
      if (!hadChangeLanguage.current) {
        setPhoneAreaCode(targetArea.code);
        phoneAreaCodeVal.current = targetArea.code;
      }
    }
    setSortAreaCodeDataList(areaCodeDataListCpoy);
  };
  /**
   * 领券成功后
   */
  const reset = () => {
    setImmediately(false);
    setAgree(false);
    setAgreePush(false);
    setPhone("");
    phoneVal.current = "";
    setVerifyCode("");
    setIsGetVerCode(false);
    getVerCodeTimer.current && clearInterval(getVerCodeTimer.current);
    currentTime.current = TIME_DURING;
    setVerCodeSecond(TIME_DURING);
    hadChangeLanguage.current = false;
    getCaptchaConfigFn();
    setEmail("");
    setLoginType(LOGIN_EMAIL);
    emailLoginVercodeBtnFlag.current = false;
    setGetSuccessDialog(false);
  };
  const selectLoginTypeFn = (val: any) => {
    setLoginTypeVisible(false);
    console.log({ val }, "val ====selectLoginTypeFn");
    const loginType = val[0];
    if (!loginType) {
      return;
    }
    if (loginType == LOGIN_EMAIL) {
      setPhone("");
    } else {
      setEmail("");
    }
    setLoginType(val[0]);
  };
  const emailLoginCheckPass = () => {
    return (
      isEmailLogin &&
      emailReg.test(email) &&
      verifyCode &&
      verifyCode.length === 6 &&
      isAgree &&
      isAgreePush
    );
  };
  const phoneLoginCheckPass = () => {
    return (
      !isEmailLogin &&
      phoneReg.test(phone) &&
      verifyCode &&
      verifyCode.length === 6 &&
      isAgree &&
      isAgreePush
    );
  };
  const { run: onReceive } = useThrottleFn(
    () => {
      // if ( loginType == LOGIN_PHONE && !phoneLoginCheckPass()) {
      //   return false;
      // }
      // if (loginType == LOGIN_EMAIL && !emailLoginCheckPass()) {
      //   return false;
      // }
      if (!(phoneLoginCheckPass() || emailLoginCheckPass())) {
        return;
      }
      if (!isAgree) {
        isCodeType = false;
        HdlToast.info(translate["请勾选同意用户许可使用协议和隐私政策"]);
        return false;
      }
      if (isCodeType) {
        return false;
      }
      isCodeType = true;
      setTimeout(() => {
        isCodeType = false;
      }, 3000);
      loadingRef.current.open();
      // 根据不同的登录方式获取参数
      let params: any = {
        accountType: "0",
        phone,
        areCode: phoneAreaCode,
        verifyCode,
        activityId: activeInfo.current?.activityId,
      };
      if (isEmailLogin) {
        params = {
          accountType: "1",
          verifyCode,
          activityId: activeInfo.current?.activityId,
          mail: email,
        };
      }
      loginAndSend({
        ...params,
      })
        .then((res: any) => {
          // console.log("res", res);
          if (res.code == 200) {
            const needToastAreas = ["HK", "MO", "TW"];
            // 港澳台需要toast
            if (needToastAreas.includes(country)) {
              HdlToast.info(translate["suc_get"], 2000);
              setTimeout(() => {
                reset();
              }, 1500);
            } else {
              // 弹框提示
              setGetSuccessDialog(true);
            }
          }
          loadingRef.current.close();
        })
        .catch((err) => {
          // console.log({err}, 'err ==============')
          // err.code && HdlToast.info((translate && translate[errorStatus[err.code]]) || err.msg);
          const _errorMsg =
            (err.code &&
              errorStatus[err.code] &&
              translate &&
              translate[errorStatus[err.code]]) ||
            err.msg ||
            err.message;
          HdlToast.info(_errorMsg);
          if (err.code === Time_End) {
            setActFailStatus(true);
          }
          loadingRef.current.close();
        });
    },
    { wait: 500 }
  );
  // 获取验证码配置时间戳
  const { run: getCaptchaConfigFn } = useThrottleFn(
    () => {
      catptchInstance?.current?.destroy();
      return new Promise<any>((resolve) => {
        getGt4Captcha({})
          .then(async (res: any) => {
            // console.log(res)
            // console.log({aa: (window as any).initGeetest4})
            if (res.code == 200) {
              riskTypeConfig.current = res.data;
              await initCaptcha();
              resolve(true);
            } else {
              HdlToast.info(res.msg);
              resolve(false);
            }
          })
          .catch((err) => {
            console.log("getGt4Captcha, err ==============", err);
            const _errorMsg =
              (err.code &&
                errorStatus[err.code] &&
                translate &&
                translate[errorStatus[err.code]]) ||
              err.msg ||
              err.message;
            HdlToast.info(_errorMsg);
            resolve(false);
          });
      });
    },
    { wait: 500 }
  );
  const startSecond = () => {
    getVerCodeTimer.current = setInterval(() => {
      if (currentTime.current < 2) {
        setIsGetVerCode(false);
        getVerCodeTimer.current && clearInterval(getVerCodeTimer.current);
        currentTime.current = TIME_DURING;
        setVerCodeSecond(TIME_DURING);
        getCaptchaConfigFn();
        // initCaptcha()
      } else {
        currentTime.current = currentTime.current - 1;
        setVerCodeSecond(currentTime.current);
      }
    }, 1000);
  };
  const initCaptcha = () => {
    return new Promise<any>((resolve, reject) => {
      try {
        catptchInstance.current?.destroy();
        (window as any)?.initGeetest4(
          {
            captchaId: "9a3b611d1312a9862043ceac6fc068b8",
            hideSuccess: true,
            riskType: riskTypeConfig.current,
            product: "bind",
            language: captchaLanguage.current,
            // language: 'ind'
          },
          function (captchaObj: any) {
            // console.log(222222, captchaObj)
            catptchInstance.current = captchaObj;
            catptchInstance.current
              ?.onReady(() => {
                // console.log('ready')
                resolve(true);
              })
              .onSuccess(async (e: any) => {
                // console.log({e, phone, val: phoneVal.current}, 'successssssssssssssssss===============')
                const _getValidate = catptchInstance.current?.getValidate();
                console.log("_getValidate", _getValidate);
                // catptchInstance.current?.reset();
                getVerifyCode({
                  accountType: "0",
                  lotNumber: _getValidate.lot_number,
                  captchaOutput: _getValidate.captcha_output,
                  passToken: _getValidate.pass_token,
                  genTime: _getValidate.gen_time,
                  mobile: phoneVal.current,
                  areaCode: phoneAreaCodeVal.current,
                })
                  .then((res: any) => {
                    // console.log(res, 'res =======================')
                    if (res.code == 200) {
                      setIsGetVerCode(true);
                      startSecond();
                      HdlToast.info(
                        translateVal.current && translateVal.current["suc_send"]
                      );
                      trackLogFn(
                        "h5_active_smscode_success_show",
                        "show",
                        "H5 领取优惠券-邮箱验证码发送成功"
                      );
                    }
                  })
                  .catch(async (err) => {
                    console.log("err", err);
                    const _errorMsg =
                      (err.code &&
                        errorStatus[err.code] &&
                        translateVal.current &&
                        translateVal.current[errorStatus[err.code]]) ||
                      err.msg ||
                      err.message;
                    // err.code && errorStatus[err.code] && HdlToast.info((translateVal.current && translateVal.current[errorStatus[err.code]]) ) ||;
                    HdlToast.info(_errorMsg);
                  });
              })
              .onClose(async (closeInfo: any) => {
                console.log({ closeInfo }, "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx");
              })
              .onFail(async (failInfo: any) => {
                console.log(
                  failInfo,
                  catptchInstance.current,
                  "catptchInstance.current?.getValidate()==================== onFail error"
                );
                HdlToast.info(
                  translateVal.current &&
                    translateVal.current["send_code_error"]
                );
              })
              .onError(async (error: any) => {
                // setTimeout(() => {
                HdlToast.info(
                  error.msg ||
                    (translateVal.current &&
                      translateVal.current["send_code_error"])
                );
                // }, 1500)
                console.log(
                  error,
                  "catptchInstance.current?.getValidate()==================== onError error",
                  translateVal.current
                );
                // alert(translateVal.current && translateVal.current['send_code_error'])
                // catptchInstance?.current?.destroy();
                // await getCaptchaConfigFn();
              });
            // captcha为验证码实例
            // captcha.appendTo("#captcha");// 调用appendTo将验证码插入到页的某一个元素中，这个元素用户可以自定义
          }
        );
      } catch (error) {
        resolve(false);
        console.log(
          error,
          "initGeetest4 ======================================="
        );
      }
    });
  };
  const { run: getVerCodeFn } = useThrottleFn(
    async () => {
      // debugger
      if (isGetVerCode) {
        return;
      }
      if (!phoneReg.test(phone) && !isEmailLogin) {
        HdlToast.info(translate && translate["phone_err"]);
        return;
      }
      if (!emailReg.test(email) && isEmailLogin) {
        HdlToast.info(translate && translate["email_error_tip"]);
        return;
      }

      if (isEmailLogin) {
        if (emailLoginVercodeBtnFlag.current) {
          return;
        }
        emailLoginVercodeBtnFlag.current = true;
        getVerifyCode({
          accountType: "1",
          mail: email,
          activityId: activeInfo.current?.activityId,
        })
          .then((res: any) => {
            // console.log(res, 'res =======================')
            if (res.code == 200) {
              setIsGetVerCode(true);
              emailLoginVercodeBtnFlag.current = false;
              startSecond();
              HdlToast.info(
                translateVal.current && translateVal.current["suc_send"]
              );
              trackLogFn(
                "h5_active_smscode_success_show",
                "show",
                "H5 领取优惠券-短信验证码发送成功"
              );
            }
          })
          .catch(async (err) => {
            // err.code && HdlToast.info((translateVal.current && translateVal.current[errorStatus[err.code]]) || err.msg);
            const _errorMsg =
              (err.code &&
                errorStatus[err.code] &&
                translate &&
                translate[errorStatus[err.code]]) ||
              err.msg ||
              err.message;
            HdlToast.info(_errorMsg);
            emailLoginVercodeBtnFlag.current = false;
          });
        return;
      }

      const _diffTime = Date.now() - catptchInstance?.current?.$_BAGm || 0;
      // console.log({_diffTime, a: catptchInstance.current})
      if (_diffTime < 1800000 && catptchInstance.current) {
        console.log("test ==========", catptchInstance.current);
        try {
          catptchInstance.current?.reset();
          catptchInstance.current?.showCaptcha();
        } catch (error) {
          console.log(error, "try catch ===========");
          await getCaptchaConfigFn();
          //  getVerCodeFn();
        }
      } else {
        console.log("timer out ==================================");
        if (!catptchInstance.current) {
          HdlToast.info(translate && translate["network_error"]);
        }
        await getCaptchaConfigFn();
      }
    },
    { wait: 500, trailing: false }
  );
  const trackLogFn = (
    identifier: TrackIdentifier,
    type: TrackType,
    eventName: TrackEventName,
    currentLanguage?: string
  ) => {
    trackLog(
      {
        eventName: eventName,
        eventIdentifier: identifier,
        eventType: type,
        eventDetail: {
          active_id: activeInfo.current.activityId || "be_null",
          active_name: activeInfo.current.activityName || "be_null",
          template_id:
            activeInfo.current?.templateIdList?.join(",") || "be_null",
          country_code: activeInfo.current?.country || "be_null",
          country: Chinese[activeInfo.current?.country] || "be_null",
        },
        currentLanguage: currentLanguage || languageSelectedInfo.languageName,
        timestamp: Date.now(),
      },
      {}
    ).catch((err) => {
      // console.log({err}, 'trackLog,err============')
      const _errorMsg =
        (err.code &&
          errorStatus[err.code] &&
          translate &&
          translate[errorStatus[err.code]]) ||
        err.msg ||
        err.message;
      HdlToast.info(_errorMsg);
    });
  };
  const btnSureFn = () => {
    reset();
    // https://appdownload-global.hdltest.com/linkTypePage?pageType=myCoupon
    let appCouponPath =
      "https://appdownload.superhi-tech.com/linkTypePage?pageType=myCoupon";
    if (window.location.href.includes(".hdltest.com")) {
      appCouponPath =
        "https://appdownload-global.hdltest.com/linkTypePage?pageType=myCoupon";
    }
    // window.location.href = appCouponPath;
    window.open(appCouponPath);
  };
  return (
    <>
      <HLoading cRef={loadingRef} />
      {actFailStatus ? (
        <div className="page">
          <div>
            <img
              className="empty_coupon"
              src={require("@/images/empty_coupon.png")}
              alt="失败"
            />
          </div>
          <div className="failText">
            {translate && translate["not_get_late"]}
          </div>
        </div>
      ) : (
        <div
          className="receiveCoupon"
          style={{ position: isImmediately ? "fixed" : "static" }}
        >
          <div className="activeBgBox">
            {detailRuleBg ? (
              <img className="activeBg" src={detailRuleBg} alt="背景图" />
            ) : null}
          </div>
          <div
            className="languageBox"
            onClick={() => {
              // console.log('dddddddd')
              setLanguageVisible(true);
            }}
          >
            <img
              className="languageIcon"
              src={require("@/images/language-icon.png")}
              alt="海底捞"
            />
            {languageSelectedInfo?.value}
            <img
              className="rightIcon"
              src={require("@/images/right-icon.png")}
              alt="海底捞"
            />
          </div>
          <div
            onClick={() => {
              // setGetSuccessDialog(true)
              // return;
              setImmediately(!isImmediately).then(() => {
                if (isEmailLogin) {
                  emailRef.current && emailRef.current.focus();
                } else {
                  phoneRef.current && phoneRef.current.focus();
                }
              });
              trackLogFn(
                "h5_active_couponpage_click",
                "click",
                "H5 领取优惠券页面按钮点击"
              );
              // setCaptcha(getCaptcha());
            }}
            className="footerDiv"
          >
            <div className="btn">{translate && translate["get_btn"]}</div>
          </div>
          {isImmediately ? (
            <div
              onClickCapture={() => {
                setImmediately(!isImmediately);
              }}
              className="conponMask immediatelyBox"
            >
              <div
                onClickCapture={() => {
                  setImmediately(isImmediately);
                }}
                className="immediatelyDiv"
              >
                <div className="title">
                  {translate && translate["get_coupon"]}
                </div>
                <img
                  src={require("@/images/hi.png")}
                  className="titleHi"
                  alt="海底捞"
                />
                <div className="immediatelyBody">
                  <div className="unregisterTip">
                    {translate && translate["unregistered_tip"]}
                  </div>
                  <div
                    className="loginTypeLine"
                    onClick={() => setLoginTypeVisible(true)}
                  >
                    <span className="loginType">
                      {translate && translate[loginType]}
                    </span>
                  </div>
                  {isEmailLogin ? null : (
                    <div
                      className="areasLine"
                      onClickCapture={() => {
                        setVisible(true);
                      }}
                    >
                      <span className="areasLineCountry">{phoneAreaName}</span>
                      <span className="areasLineCode">{phoneAreaCode}</span>
                    </div>
                  )}

                  {isEmailLogin ? (
                    <div className="emailLine">
                      <input
                        ref={emailRef}
                        type="text"
                        value={email}
                        onChange={(e: any) => {
                          let value = e.target.value;
                          setEmail(value);
                        }}
                        className="emailInput"
                        placeholder={translate && translate["email"]}
                      />
                    </div>
                  ) : (
                    <div className="phoneLine">
                      <input
                        ref={phoneRef}
                        type="text"
                        value={phone}
                        onChange={(e: any) => {
                          let value = e.target.value;

                          if (
                            (/^[0-9]*$/.test(value) && value.length < 12) ||
                            !value
                          ) {
                            setPhone(value);
                            phoneVal.current = value;
                          }
                        }}
                        className="phoneInput"
                        placeholder={translate && translate["phone_number"]}
                      />
                    </div>
                  )}

                  <div className="codeLine">
                    <input
                      value={verifyCode}
                      className="codeInput"
                      onInput={(e: any) => {
                        let value = e.target.value;
                        if (
                          (/^[0-9]*$/.test(value) && value.length < 7) ||
                          !value
                        ) {
                          setVerifyCode(value);
                        }
                      }}
                      placeholder={translate && translate["ver_code"]}
                    />
                    <div className="codeTip" onClick={getVerCodeFn}>
                      {/* { isGetVerCode ?  : translate && translate["get_ver_code"]} */}
                      {isGetVerCode
                        ? templateReplace(
                            translate && translate["retrieve_ver_code"],
                            { SECONDS: verCodeSecond }
                          )
                        : translate && translate["get_ver_code"]}
                    </div>
                  </div>
                  <div className="agreementLine">
                    <div
                      onClickCapture={() => {
                        setAgree(!isAgree);
                      }}
                      className="img"
                    >
                      {" "}
                      <img
                        src={require(isAgree
                          ? "@/images/agreement-select.png"
                          : "@/images/agreement-no-select.png")}
                        alt="选择框"
                      />
                    </div>
                    <p className="text">
                      <span
                        onClickCapture={() => {
                          setAgree(!isAgree);
                        }}
                      >
                        {translate && translate["age_tip"]}
                      </span>
                      <span
                        className="text red"
                        onClick={() => {
                          goToPage("privacy", country, languageCode.current);
                        }}
                      >
                        {translate && translate["PRIVICY_POLICY"]}
                      </span>
                      {translate && translate["and"]}
                      <span
                        className="text red"
                        onClick={() => {
                          goToPage("user", country, languageCode.current);
                        }}
                      >
                        {translate && translate["MEMBER_AGGREMENT"]}
                      </span>
                      {languageSelectedInfo.languageCode == "KR" ||
                      languageSelectedInfo.languageCode == "JP" ? (
                        <span
                          onClickCapture={() => {
                            setAgree(!isAgree);
                          }}
                        >
                          {translate && translate["age_tip_1"]}
                        </span>
                      ) : null}
                    </p>
                  </div>
                  <div
                    className="agreementLine marginTop12 marginBottom36px"
                    onClickCapture={() => {
                      setAgreePush(!isAgreePush);
                    }}
                  >
                    <div className="img">
                      {" "}
                      <img
                        src={require(isAgreePush
                          ? "@/images/agreement-select.png"
                          : "@/images/agreement-no-select.png")}
                        alt="选择框"
                      />
                    </div>
                    <p className="text">
                      {translate && translate["agree_push"]}
                    </p>
                  </div>
                  <Divider style={{ width: "100%", margin: 0 }} />
                  <div
                    className={[
                      "receiveBtn",
                      phoneLoginCheckPass() || emailLoginCheckPass()
                        ? "high"
                        : "",
                    ].join(" ")}
                    onClickCapture={onReceive}
                  >
                    {translate && translate["get_btn"]}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          <CenterPopup
            visible={visible}
            onMaskClick={() => {
              setVisible(false);
            }}
            destroyOnClose
          >
            <div className="areaBox">
              <CheckList
                className="areaList"
                onChange={(val) => {
                  // console.log({val})
                  setPhoneAreaCode(val[0] as string);
                  phoneAreaCodeVal.current = val[0] as string;
                  setVisible(false);
                  hadChangeLanguage.current = true;
                }}
                style={{
                  "--font-size": $vw(16),
                  "--padding-right": $vw(32),
                  "--border-bottom": "none",
                  "--border-top": "none",
                  "--border-inner": "1px solid #f4f4f4",

                  // '--padding-left': $vw(32)
                }}
              >
                {sortAreaCodeDataList.map((item) => (
                  <CheckList.Item
                    key={item.key}
                    value={item.code}
                    className="listItem"
                  >
                    <div className="areaItem">
                      <div>{translate && translate[item.country]}</div>
                      <div className="phoneArea">{item.code}</div>
                    </div>
                  </CheckList.Item>
                ))}
              </CheckList>
            </div>
          </CenterPopup>
          <CenterPopup
            visible={languageVisible}
            onMaskClick={() => {
              setLanguageVisible(false);
            }}
            destroyOnClose
          >
            <div className="languagePopBox">
              <CheckList
                className="languagePopList"
                defaultValue={[languageValue]}
                value={[languageValue]}
                onChange={(val) => selectLanguageFn(val)}
                style={{
                  "--font-size": $vw(16),
                  "--padding-right": $vw(32),
                  "--border-bottom": "none",
                  "--border-top": "none",
                  "--border-inner": "1px solid #f4f4f4",
                }}
                activeIcon={
                  <img
                    className="languageSelected"
                    src={require("@/images/language-selected.png")}
                    alt="选择框"
                  />
                }
              >
                {languageSelectList.map((item) => (
                  <CheckList.Item
                    key={item.value}
                    value={item.value}
                    className="listItem"
                  >
                    <div className="languagePopItem">
                      <div>{item.value}</div>
                    </div>
                  </CheckList.Item>
                ))}
              </CheckList>
            </div>
          </CenterPopup>
          <CenterPopup
            visible={loginTypeVisible}
            onMaskClick={() => {
              setLoginTypeVisible(false);
            }}
            destroyOnClose
          >
            <div className="languagePopBox">
              <CheckList
                className="languagePopList"
                defaultValue={[loginType]}
                value={[loginType]}
                onChange={(val) => selectLoginTypeFn(val)}
                style={{
                  "--font-size": $vw(16),
                  "--padding-right": $vw(32),
                  "--border-bottom": "none",
                  "--border-top": "none",
                  "--border-inner": "1px solid #f4f4f4",
                }}
                activeIcon={
                  <img
                    className="languageSelected"
                    src={require("@/images/language-selected.png")}
                    alt="选择框"
                  />
                }
              >
                {loginTypeList.map((item) => (
                  <CheckList.Item
                    key={item.value}
                    value={item.value}
                    className="listItem"
                  >
                    <div className="languagePopItem">
                      <div>{translate && translate[item.value]}</div>
                    </div>
                  </CheckList.Item>
                ))}
              </CheckList>
            </div>
          </CenterPopup>
          {getSuccessDialog ? (
            <div
              // onClickCapture={() => {
              //   setGetSuccessDialog(!getSuccessDialog);
              // }}
              className="conponMask immediatelyBox"
            >
              <div
                // onClickCapture={() => {
                //   setGetSuccessDialog(!getSuccessDialog);
                // }}
                className="immediatelyDiv"
              >
                <div className="title">{translate && translate["suc_get"]}</div>
                <img
                  src={require("@/images/hi.png")}
                  className="titleHi"
                  alt="海底捞"
                />
                <div className="successDialogBody">
                  {/* <div className="successDialogBody"> */}
                  <div className="unregisterTip">
                    {country == "JP" || country == "TH"
                      ? translate && translate["suc_dialog_text"]
                      : translate && translate["suc_get_dialog_text"]}
                  </div>
                  {/* </div> */}
                  <Divider style={{ width: "100%", marginBottom: $vw(20) }} />
                  <div className="footerBtnBox">
                    <span className="footerBtn" onClick={() => reset()}>
                      {country == "JP" || country == "TH"
                        ? translate && translate["btn_return"]
                        : translate && translate["btn_cancel"]}
                    </span>
                    <Divider
                      direction="vertical"
                      style={{ width: "2px", height: "32px" }}
                    />
                    <span className="footerBtn sure" onClick={btnSureFn}>
                      {country == "JP" || country == "TH"
                        ? translate && translate["btn_download"]
                        : translate && translate["btn_sure"]}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </>
  );
};

export default ReceiveCoupon;
